import Settings from '@/config/Settings'

console.log.apply(console, [
  `%c ♥ ${Settings.author} ♥ `,
  'color: #fff; background: #030307; padding:5px 0;'
])




// WEBPACK FOOTER //
// ./src/core/js/Copyright.js